import {
  mapGetters,
  mapMutations,
} from 'vuex';

import {
  TireLocationPickerItem,
} from '@/components';

import CarIcon from '@/assets/images/car-types/car.svg';
import BusIcon from '@/assets/images/car-types/bus.svg';

export default {
  name: 'TireLocationPicker',
  components: {
    [TireLocationPickerItem.name]: TireLocationPickerItem,
    CarIcon,
    BusIcon,
  },
  props: {
    title: '',
  },
  data: () => ({}),
  computed: {
    ...mapGetters('appointment', {
      serviceType: 'getServiceType',
      tireType: 'getTireType',
      tireLocations: 'getTireLocations',
      tireStock: 'getTireStock',
      bodyworkType: 'getBodyworkType',
      vehiculeType: 'getVehiculeType',
    }),
    checkIfTPP() {
      return this.$route.path.includes('tpp');
    },
    showStockInfoMessageState() {
      return this.tireStock[this.tireType] > 0;
    },
    showNewTiresInfoMessageState() {
      return this.tireStock[this.tireType] === 0 && this.serviceType !== 'change';
    },
    showStockErrorMessageState() {
      return !(this.bodyworkType === 'car' && this.tireStock[
        this.tireType] === 4) && !(this.bodyworkType === 'bus' && this.tireStock[this
        .tireType] === 6);
    },
  },
  methods: {
    ...mapMutations('appointment', {
      setTireLocationMutation: 'SET_TIRELOCATION',
      setBodyworkTypeMutation: 'SET_BODYWORKTYPE',
    }),
    setBodyworkType(carType) {
      this.setBodyworkTypeMutation(carType);
    },
  },
};
